export const localGlobal = window as any;

const identityUrl = "https://identity.axxessweb.com";
const localIdentityUrl = "https://localhost:5001";
const _releaseVersion: string =
  localGlobal._releaseVersion == null ? "" : localGlobal._releaseVersion; // Will be replaced by Octopus on deployment.
const _releaseEnvironment: string =
  localGlobal._releaseEnvironment == null
    ? ""
    : localGlobal._releaseEnvironment; // Will be replaced by Octopus on deployment.
const _releaseTimestamp: string =
  localGlobal._releaseTimestamp == null ? "" : localGlobal._releaseTimestamp; // Will be replaced by Octopus on deployment.
const _buildVersion: string =
  localGlobal._buildVersion == null ? "" : localGlobal._buildVersion; // Will be replaced by TeamCity on build.
const _authorityUrl: string =
  localGlobal._authorityUrl.startsWith("#") || localGlobal._authorityUrl == null
    ? identityUrl
    : localGlobal._authorityUrl; // Will be replaced by Octopus on deployment.
const _dsnMappings: { [key: string]: string } = {
  Production: null,
  Staging: null,
  Development: null,
  Local: null
}; // TODO - Hack, we need transforms for JS. This should not be included in all releases.

export class ReleaseEnvironments {
  public static readonly production: string = "Production";
  public static readonly staging: string = "Staging";
  public static readonly development: string = "Development";
  public static readonly testing: string = "Testing";
  public static readonly local: string = "Local";
  public static readonly feature1: string = "Development";

}

export default class Infrastructure {
  public static get releaseVersion(): string {
    return _releaseVersion.startsWith("#") ? "0.0.0.1" : _releaseVersion;
  }

  public static get releaseEnvironment(): string {
    return _releaseEnvironment.startsWith("#")
      ? ReleaseEnvironments.local
      : _releaseEnvironment;
  }

  public static get authorityUrl(): string {
    return this.releaseEnvironment == ReleaseEnvironments.local
      ? localIdentityUrl
      : _authorityUrl;
  }

  public static get buildVersion(): string {
    return _buildVersion.startsWith("#") ? "0.0.0.2" : _buildVersion;
  }

  public static get releaseTimestamp(): string {
    return _releaseTimestamp.startsWith("#")
      ? new Date().toString()
      : _releaseTimestamp;
  }

  public static get sentryDsn(): string {
    return _dsnMappings[this.releaseEnvironment];
  }

  public static get isProduction(): boolean {
    return _releaseEnvironment == ReleaseEnvironments.production;
  }
}
